import { render, staticRenderFns } from "./myClient.vue?vue&type=template&id=90cc8e7c"
import script from "./myClient.vue?vue&type=script&lang=js"
export * from "./myClient.vue?vue&type=script&lang=js"
import style0 from "./myClient.vue?vue&type=style&index=0&id=90cc8e7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports